// extracted by mini-css-extract-plugin
export default {"rowMarginBottom":"rowMarginBottom---i3do6","multiTitle":"multiTitle---bUzGw","warnIcon":"warnIcon---H5gxl","boundWithIcon":"boundWithIcon---TrAMg"};